import { RadioButton, RadioGroup } from '@ksyos/design-system';
import { translateKey } from '../../../../../translate';

interface ISettingsSwitchProps {
    disabled?: boolean;
    error?: string;
    listKey: string;
    onBlur?: () => void;
    onChange: (value: boolean) => void;
    value: boolean | undefined;
}

export function SettingsSwitch(props: ISettingsSwitchProps) {
    return (
        <RadioGroup
            error={props.error}
            layout="row"
            name={props.listKey}
            onBlur={props.onBlur}
            onChange={(event) => props.onChange(event.target.value === 'true')}
            value={props.value?.toString() ?? ''}
        >
            <RadioButton
                disabled={props.disabled}
                label={translateKey('common.yes')}
                value={'true'}
            />
            <RadioButton
                disabled={props.disabled}
                label={translateKey('common.no')}
                value={'false'}
            />
        </RadioGroup>
    );
}
